/**
 * UploadFile function handles the file upload process and display the import button.
 *
 * @param {Object} props - The properties object.
 * @param {File} props.file - The file to be uploaded.
 * @param {string} props.referentiel - The reference ID for the upload.
 * @param {TerrUnitArray[]} props.terrUnit - The territorial units associated with the file.
 * @param {number} props.tab - The current tab index to determine the import type.
 * @param {Function} props.setActiveStep - Function to set the active step in the upload process.
 * @param {Function} props.setFileData - Function to set the file data after upload.
 *
 * @returns {JSX.Element} The UploadFile function.
 */

import Button from '@mui/material/Button';
import PublishIcon from '@mui/icons-material/Publish';
import { StoreFile } from '../../hooks/store';
import { TerrUnitArray } from '@front-ends/common/src/utils/types/TerrUnitTypes';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function UploadFile({ file, referentiel, terrUnit, tab, setActiveStep, setFileData, importTime }: any) {

  const { t } = useTranslation();
  
	const { upload, response } = StoreFile();

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleUpload = async () => {
    if (file) {
      const formData = new FormData();
      const importType = tab === 0 ? "biblio" : "status-biblio";
      var terrUnitKey = "";
      formData.append("fileToUpload", file);
      formData.append("refId", referentiel);
      if (terrUnit.length > 0) {
        terrUnitKey = terrUnit.map((unit: TerrUnitArray) => unit.key).join(",");
        formData.append("terrUnits", terrUnitKey);
      } else {
        formData.append("terrUnits", "");
      }
      upload(formData, importType).then(async () => {
        setActiveStep(1);
      });
    }
  };

  useEffect(() => {
    setFileData(response);
  }, [response]);

	return (
    <Box sx={{
      display:"flex",
      justifyContent:" center",
      minWidth: 300
    }}>
      {importTime >= 10 ? (
        <>
          <Button
            startIcon={<PublishIcon />}
            color='primary'
            onClick={handleClickOpen}
            variant='outlined'
            sx={{ mr: 1 }}
          >
            {t("import-button")}
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              ⚠️ {t("warning-title")} ⚠️
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {t("warning-text-3")}<br/>
              {t("warning-text-4")}
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>{t('no-text')}</Button>
            <Button onClick={handleUpload} autoFocus>
              {t('yes-text')}
            </Button>
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <Button
                startIcon={<PublishIcon />}
                color='primary'
                onClick={handleUpload}
                variant='outlined'
                sx={{ mr: 1 }}
              >
          {t("import-button")}
        </Button>
      )}
    </Box> 
	);
}